<template>
    <b-modal ref="mdlConfigurazioniFornitori" :title="title" centered no-close-on-backdrop no-close-on-esc hide-header-close size="lg" @shown="onShow">
        <b-row>
            <b-col cols="12" xs="12" sm="6" md="4" lg="4" xl="4">
                <label class="sa-label-data">Ragione Sociale:</label>
                <span v-if="isReadOnly"> {{ jsonDataFornitori.ragioneSocialeFornitore }} </span>
                <b-form-input v-else v-model="jsonDataFornitori.ragioneSocialeFornitore"> </b-form-input>
            </b-col>
            <b-col cols="12" xs="12" sm="6" md="4" lg="4" xl="4">
                <label class="sa-label-data">P.Iva:</label>
                <span v-if="isReadOnly"> {{ jsonDataFornitori.partitaIvaFornitore }}</span>
                <b-form-input v-else v-model="jsonDataFornitori.partitaIvaFornitore"></b-form-input>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <label class="sa-label-data">Codice fornitore:</label>
                <span v-if="isReadOnly">{{ jsonDataFornitori.codiceFornitore }}</span>
                <b-form-input v-else v-model="jsonDataFornitori.codiceFornitore"></b-form-input>
            </b-col>
            <b-col cols="12" xs="12" sm="6" md="4" lg="4" xl="4" v-if="!isReadOnly">
                <label class="sa-label-data">Regione: </label>
                <b-form-select v-model="regione" :options="regioneOptions" text-field="regione" value-field="codiceIstat" @change="onChangeRegioneResidenza">
                    <template #first>
                        <b-form-select-option :value="null" disabled> - Seleziona Regione - </b-form-select-option>
                    </template>
                </b-form-select>
            </b-col>
            <b-col cols="12" xs="12" sm="6" md="4" lg="4" xl="4">
                <label class="sa-label-data">Provincia: </label>
                <span v-if="isReadOnly"> {{ jsonDataFornitori.provinciaFornitore }}</span>
                <b-form-select v-else v-model="jsonDataFornitori.provinciaFornitore" :options="provinceOptions" text-field="provincia" value-field="codiceIstat" @change="onChangeProvincia">
                    <template #first>
                        <b-form-select-option :value="null" disabled> - Seleziona Provincia - </b-form-select-option>
                    </template>
                </b-form-select>
            </b-col>
            <b-col cols="12" xs="12" sm="6" md="4" lg="4" xl="4">
                <label class="sa-label-data">Località:</label>
                <span v-if="isReadOnly">{{ jsonDataFornitori.localitaFornitore }}</span>
                <b-form-select v-else v-model="jsonDataFornitori.localitaFornitore" :options="localitaOptions" text-field="comune" value-field="codiceIstat">
                    <template #first>
                        <b-form-select-option :value="null" disabled> - Seleziona Località - </b-form-select-option>
                    </template>
                </b-form-select>
            </b-col>
            <b-col cols="12" xs="12" sm="6" md="4" lg="4" xl="4">
                <label class="sa-label-data">Indirizzo:</label>
                <span v-if="isReadOnly">{{ jsonDataFornitori.indirizzoFornitore }}</span>
                <b-form-input v-else v-model="jsonDataFornitori.indirizzoFornitore"></b-form-input>
            </b-col>
            <b-col cols="12" xs="12" sm="6" md="4" lg="4" xl="4">
                <label class="sa-label-data">Cap:</label>
                <span v-if="isReadOnly">{{ jsonDataFornitori.capFornitore }}</span>
                <b-form-input v-else v-model="jsonDataFornitori.capFornitore"></b-form-input>
            </b-col>
            <b-col cols="12" xs="12" sm="6" md="4" lg="4" xl="4">
                <label class="sa-label-data">Telefono:</label>
                <span v-if="isReadOnly">{{ jsonDataFornitori.telefonoFornitore }}</span>
                <b-form-input v-else v-model="jsonDataFornitori.telefonoFornitore"></b-form-input>
            </b-col>
            <b-col cols="12" xs="12" sm="6" md="4" lg="4" xl="4">
                <label class="sa-label-data">Email:</label>
                <span v-if="isReadOnly">{{ jsonDataFornitori.emailFornitore }}</span>
                <b-form-input v-else v-model="jsonDataFornitori.emailFornitore"></b-form-input>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <label class="sa-label-data">Note:</label>
                <span v-if="isReadOnly">{{ jsonDataFornitori.note }}</span>
                <b-textarea v-else v-model="jsonDataFornitori.note" rows="7" max-rows="10"></b-textarea>
            </b-col>
        </b-row>
        <template #modal-footer>
            <b-button v-if="!isReadOnly" size="md" variant="outline-danger" @click="onCloseModal">Annulla</b-button>
            <b-button v-if="!isReadOnly" size="md" variant="outline-success" @click="onClickSalvaFornitore">Salva</b-button>
            <b-button v-if="isReadOnly" size="md" variant="outline-secondary" @click="onCloseModal">Chiudi</b-button>
        </template>
        <modal-error ref="cmpModalError"></modal-error>
    </b-modal>
</template>

<script>
import UtilityMixin from "../../utility/UtilityMixin";
import ModalError from "../../../template/components/modal/components/ModalError.vue";
import axios from "axios";

export default {
    name: "ConfigurazioneMagazzinoFornitoriModalEditComponent",
    mixins: [UtilityMixin],
    components: { ModalError },
    data() {
        return {
            pathResourceFornitori: "/magazzinofornitori",
            pathResourceProvince: "/province",
            pathResourceRegioni: "/regioni",
            pathResourceLocalita: "/comuni/provincia", //Endpoint usato per i comuni/località
            pathResourceComuni: "/comuni/istat", //Endpoint usato per il cap
            title: null,
            isReadOnly: false,
            provinceOptions: [],
            regioneOptions: [],
            localitaOptions: { comune: "prova" },
            regione: null,
            filtro: [],
            jsonDataFornitori: {
                id: null,
                ragioneSocialeFornitore: null,
                partitaIvaFornitore: null,
                capFornitore: null,
                indirizzoFornitore: null,
                provinciaFornitore: null,
                localitaFornitore: null,
                telefonoFornitore: null,
                emailFornitore: null,
                codiceFornitore: null,
                note: null,
            },
        };
    },
    methods: {
        // ==================== CRUD ====================
        loadDataRegioni() {
            let me = this;
            me.regioneOptions = [];
            let link = process.env.VUE_APP_PATH_API + me.pathResourceRegioni;
            axios
                .get(link)
                .then((response) => {
                    response.data.data.forEach((regione) => {
                        me.regioneOptions.push(regione);
                    });
                })
                .catch((error) => {
                    console.log("Il servizio delle regioni ha datao errore: " + error.response.status);
                });
        },
        loadDataProvincie(regione) {
            let me = this;
            console.log("LoadDataProvincie con regione: ", regione);
            me.filtro = { regione: regione };
            me.provinceOptions = [];
            let link = process.env.VUE_APP_PATH_API + me.pathResourceProvince;
            axios.get(link, { params: me.filtro }).then((response) => {
                response.data.data.forEach((provincia) => {
                    me.provinceOptions.push(provincia);
                });
            });
        },
        loadLocalita(codiceIstat) {
            let me = this;
            console.log("codiceIstat: ", codiceIstat);
            let link = process.env.VUE_APP_PATH_API + me.pathResourceLocalita + "/" + codiceIstat;
            axios
                .get(link)
                .then((response) => {
                    response.data.data.forEach((comune) => {
                        me.localitaOptions.push(comune);
                    });
                })
                .catch((error) => {
                    console.log("Il servizio delle province ha datao errore: " + error.response.status);
                });
        },
        onClickSalvaFornitore() {
            let me = this;
            UtilityMixin.methods.saveResource(me.pathResourceFornitori, me.jsonDataFornitori, me.salvaFornitoreSuccess, me.salvaFornitoreError);
        },
        salvaFornitoreSuccess(response) {
            let me = this;
            me.$emit("saveFornitore", response);
            me.$bvToast.toast("Salvataggio avvenuto con successo", {
                title: "Successo",
                variant: "success",
                solid: true,
            });
            me.$refs.mdlConfigurazioniFornitori.hide();
        },
        salvaFornitoreError(error) {
            let me = this;
            me.$emit("saveFornitore", error);
            me.$refs.cmpModalError.show(error.response.data.messaggio);
        },
        onDeleteFornitore(item) {
            let me = this;
            me.$bvModal
                .msgBoxConfirm("Sei sicuro di eliminare questo fornitore?", {
                    title: "Eliminazione Fornitore",
                    buttonSize: "sm",
                    okTitle: "SI",
                    cancelTitle: "NO",
                    okVariant: "danger",
                    cancelVariant: "secondary",
                    hideHeaderClose: true,
                    footerClass: "p-2",
                    centered: true,
                })
                .then((value) => {
                    if (value) {
                        me.deleteFornitore(item.id);
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        deleteFornitore(id) {
            let me = this;
            UtilityMixin.methods.deleteResource(me.pathResourceFornitori + "/" + id, null, me.deleteFornitoreSuccess, me.deleteFornitoreError);
        },
        deleteFornitoreSuccess(response) {
            let me = this;
            me.$emit("fornitoreDelete", response);
            me.$bvToast.toast("Eliminazione avvenuta con successo", {
                title: "Successo",
                variant: "success",
                solid: true,
            });
        },
        deleteFornitoreError(response) {
            let me = this;
            me.$emit("fornitoreDelete", response);
            me.$bvToast.toast("Errore durante l'eliminazione", {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
        },
        // ==================== UTILITY ====================
        show(jsonDataFornitori, isReadOnly) {
            let me = this;
            me.jsonDataFornitori = jsonDataFornitori;
            me.isReadOnly = isReadOnly;
            if (isReadOnly) {
                me.title = "Dettagli Fornitore";
            } else {
                me.title = !jsonDataFornitori.id ? "Nuovo Fornitore" : "Aggiorna Fornitore";
            }
            me.$refs.mdlConfigurazioniFornitori.show();
        },
        onCloseModal() {
            let me = this;
            me.jsonDataFornitori = {
                id: null,
                ragioneSocialeFornitore: null,
                partitaIvaFornitore: null,
                capFornitore: null,
                indirizzoFornitore: null,
                provinciaFornitore: null,
                localitaFornitore: null,
                telefonoFornitore: null,
                emailFornitore: null,
                codiceFornitore: null,
                note: null,
            };
            me.$emit("onCloseModal");
            me.$refs.mdlConfigurazioniFornitori.hide();
        },
        onShow() {
            let me = this;
            me.loadDataRegioni();
            // me.loadDataProvincie();
        },
        onChangeRegioneResidenza(regione) {
            let me = this;
            me.provinceOptions.unshift({ sigla: null, provincia: "-Seleziona Provincia-" });
            me.loadDataProvincie(regione);
        },
        onChangeProvincia(provincia) {
            let me = this;
            console.log("onChangeProvincia: ", provincia);

            me.loadLocalita(provincia);
        },
    },
};
</script>

<style></style>
